import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import { GET_REGION, } from "../../actions";
import DashboardCard from "../../control-components/dashboard-card/dashboard-card";
import clinic_color from "../../assets/images/clinic-color.svg"
import clinic_users from "../../assets/images/clinic-users.svg"
import clinic_patients from "../../assets/images/clinic-Patient.svg"
import online_users from "../../assets/images/online-users.svg"
import total_billing from "../../assets/images/Total-billing.svg"
import claimIcon from "../../assets/images/claimIcon.svg"
import userSeat from "../../assets/images/userSeatIcon.svg"
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { dashboardService } from "../../services/dashboardService";
import DashBoardCardDetails from "./dashboardcard_details";
import moment from "moment";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";


function Dashboard() {
  const dispatch = useDispatch();
  const siteIds = useSelector((state) => state.getSiteId);
  const [loadingOnlineUsers, setLoadingOnlineUsers] = useState(false);
  const [loadingClinicCount, setLoadingClinicCount] = useState(false);
  const [loadingStaffCount, setLoadingStaffCount] = useState(false);
  const [loadingAllClientCount, setLoadingAllClientCount] = useState(false);
  const [loading835Billing, setLoading835Billing] = useState(false);
  const [loading837Billing, setLoading837Billing] = useState(false);
  const [onlineusersData, setOnlineUsersData] = useState([]);
  const [allStaffData, setAllStaffData] = useState([]);
  const [allClinicData, setAllClinicData] = useState([]);
  const [allClientData, setAllClientData] = useState([]);
  const [billingData835, setBillingData835] = useState([]);
  const [billingData837, setBillingData837] = useState([]);
  const [totalOnlineStaffCount, setTotalOnlineStaffCount] = useState(0);
  const [totalStaffCount, setTotalStaffCount] = useState(0);
  const [totalClinicCount, setTotalClinicCount] = useState(0);
  const [totalClientCount, setTotalClientCount] = useState(0);
  const [total835BillingCount, setTotal835BillingCount] = useState(0);
  const [total837BillingCount, setTotal837BillingCount] = useState(0);
  const [loadingClaimsBilled, setLoadingClaimsBilled] = useState(false);
  const [claimsBilledData, setClaimsBilledData] = useState([]);
  const [totalClaimsBilledCount, setTotalClaimsBilledCount] = useState(0);
  const [seatsLoading, setSeatsLoading] = useState(false);
  const [userSeatsHistory, setUserSeatsHistory] = useState([]);
  const [totalSeatsHistoryCount, setTotalSeatsHistoryCount] = useState(0);
  const [seatListToView, setSelectedSeatList] = useState([]);
  const [totalSeatsHistoryCountPrevious, setTotalSeatsHistoryCountPrevious] = useState(0);
  const [day, setDay] = useState({ name: "All Time", value: "1" });
  const [customStartDate, setCustomStartDate] = useState(moment().subtract(7, 'days').toDate());
  const [customEndDate, setCustomEndDate] = useState(moment().toDate());
  const Days = [
    { name: "All Time", value: 1 },
    { name: "Month to Date", value: "MTD" },
    { name: "In Last 3 Months", value: 3 },
    { name: "In Last 6 Months", value: 6 },
    { name: "In Last 9 Months", value: 9 },
    { name: "YTD", value: "ytd" },
    { name: "Custom Range", value: "custom" }
  ];

  const getMyTime = () => {
    const today = moment();
    let startDate, endDate;
    if (!day || !day.value) {
      return;
    }

    switch (String(day.value).toUpperCase()) {
      case "1":
        startDate = null;
        endDate = null;
        break;
      case "MTD":
        startDate = today.clone().startOf('month');
        endDate = today.clone();
        break;
      case "3":
        startDate = today.clone().subtract(2, 'months').startOf('month');
        endDate = today.clone();
        break;
      case "6":
        startDate = today.clone().subtract(5, 'months').startOf('month');
        endDate = today.clone();
        break;
      case "9":
        startDate = today.clone().subtract(8, 'months').startOf('month');
        endDate = today.clone();
        break;
      case "YTD":
        startDate = today.clone().startOf('year');
        endDate = today.clone();
        break;
      case "CUSTOM":
        startDate = moment(customStartDate);
        endDate = moment(customEndDate);
        break;
      default:
        startDate = today.clone().startOf('month');
        endDate = today.clone();
    }


    return {
      startDate: startDate?.toDate(),
      endDate: endDate?.toDate()
    };
  };

  const handleChange = (e) => {
    if (e?.target?.value) {
      const selectedDays = Days?.find((item) => item?.value === e?.target?.value?.value)
      setDay(selectedDays);

      if (selectedDays?.value === "custom") {
        setCustomStartDate(moment().subtract(7, 'days').toDate());
        setCustomEndDate(moment().toDate());
      }
    }
    else {
      var defaultValue = { name: "All Time", value: 1 }
      setDay(defaultValue);
    }

  };

  const resetDashboardStates = () => {
    setLoadingOnlineUsers(false);
    setLoadingClinicCount(false);
    setLoadingStaffCount(false);
    setLoadingAllClientCount(false);
    setLoading835Billing(false);
    setLoading837Billing(false);
    setAllStaffData([]);
    setAllClinicData([]);
    setAllClientData([]);
    setBillingData835([]);
    setBillingData837([]);
    setTotalStaffCount(0);
    setTotalClinicCount(0);
    setTotalClientCount(0);
    setTotal835BillingCount(0);
    setTotal837BillingCount(0);
    setLoadingClaimsBilled(false);
    setClaimsBilledData([]);
    setTotalClaimsBilledCount(0);
    setSeatsLoading(false);
    setUserSeatsHistory([]);
    setTotalSeatsHistoryCount(0);
    setSelectedSeatList([]);
  };
  useEffect(() => {
    const dateFilter = getMyTime();
    if (!dateFilter) {
      return;
    }
    var data = {};
    const { startDate, endDate } = dateFilter;
    if (startDate === undefined || endDate === undefined) {
      data = {
        startDate: null,
        endDate: null,
      };
    }
    else {
      data = {
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      };

    }
    resetDashboardStates()
    if (totalOnlineStaffCount === 0) {
      getOnlineUsersCount()
    }
    getAllStaffCount(data)
    getAllClinicCount(data)
    getAllClientsCount(data)
    get835BillingsCount(data)
    get837BillingsCount(data)
    getBillingClaimsCount(data)
    getSeatsHistory(data)
    if (totalSeatsHistoryCountPrevious === 0) {
      getPreviousMonthsSeatsHistory()
    }
  }, [day, customStartDate, customEndDate])

  Array.prototype.sum = function (prop) {
    var total = 0
    for (var i = 0, _len = this.length; i < _len; i++) {
      total += this[i][prop]
    }
    return total
  }


  async function getOnlineUsersCount() {
    setLoadingOnlineUsers(true);
    await dashboardService
      .GetAllOnlineStaffCount()
      .then((result) => {
        if (result.resultData.length > 0) {
          setOnlineUsersData(result.resultData)
          setTotalOnlineStaffCount(result.resultData.sum("onlineStaffCount"))
        }
        setLoadingOnlineUsers(false);
      })
      .catch((error) => {
        setLoadingOnlineUsers(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  }

  async function getAllClientsCount(data) {
    setLoadingAllClientCount(true);

    setAllClientData([]);

    await dashboardService
      .getAllClientsCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clientResponse = result.resultData;
          let totalCounter = 0;
          const newClientData = [];

          clientResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region, onlineStaffCount: clinicItem.amt }
            let ClinicActiveCount = 0;
            let ClinicInActiveCount = 0;

            if (clinicItem.totalClientsCount.length > 0) {
              clinicItem.totalClientsCount.map((countObj) => {
                if (countObj.isActive) {
                  totalCounter = totalCounter + countObj.clientCount
                  ClinicActiveCount = countObj.clientCount;
                } else {
                  ClinicInActiveCount = countObj.clientCount;
                }
              })
            }

            const countObj = ClinicActiveCount + " (A) " + ClinicInActiveCount + " (I)"
            clinicObj = { ...clinicObj, onlineStaffCount: countObj }
            newClientData.push(clinicObj);
          })

          setAllClientData(newClientData);
          setTotalClientCount(totalCounter)
        }
        setLoadingAllClientCount(false);
      })
      .catch((error) => {
        setLoadingAllClientCount(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  }
  async function getAllStaffCount(data) {
    setLoadingStaffCount(true);
    setAllStaffData([]);

    await dashboardService
      .GetAllStaffCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clinicResponse = result.resultData;
          let totalCounter = 0;
          const newStaffData = [];
          clinicResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region }
            let ClinicActiveCount = 0;
            let ClinicInActiveCount = 0;

            if (clinicItem.totalStaffCount.length > 0) {
              clinicItem.totalStaffCount.map((countObj) => {
                if (countObj.isActive) {
                  totalCounter = totalCounter + countObj.staffCount
                  ClinicActiveCount = countObj.staffCount;
                } else {
                  ClinicInActiveCount = countObj.staffCount;
                }
              })
            }

            const countObj = ClinicActiveCount + " (A) " + ClinicInActiveCount + " (I)"
            clinicObj = { ...clinicObj, onlineStaffCount: countObj }
            newStaffData.push(clinicObj);
          })

          setAllStaffData(newStaffData);
          setTotalStaffCount(totalCounter)
        }
        setLoadingStaffCount(false);
      })
      .catch((error) => {
        setLoadingStaffCount(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  }

  async function getAllClinicCount(data) {
    setLoadingClinicCount(true);
    setAllClinicData([]);

    await dashboardService
      .GetAllClinicCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clinicResponse = result.resultData;
          let totalCounter = 0;
          const newClinicData = [];

          clinicResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region }
            let ClinicActiveCount = 0;
            let ClinicInActiveCount = 0;

            if (clinicItem.clinicCount.length > 0) {
              clinicItem.clinicCount.map((countObj) => {
                if (countObj.isActive) {
                  ClinicActiveCount = countObj.clinicCount;
                  totalCounter = totalCounter + countObj.clinicCount
                } else {
                  ClinicInActiveCount = countObj.clinicCount;
                }
              })
            }

            const countObj = ClinicActiveCount + " (A) " + ClinicInActiveCount + " (I)"
            clinicObj = { ...clinicObj, onlineStaffCount: countObj }
            newClinicData.push(clinicObj);
          })

          setAllClinicData(newClinicData);
          setTotalClinicCount(totalCounter)
        }
        setLoadingClinicCount(false);
      })
      .catch((error) => {
        setLoadingClinicCount(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  }

  async function get835BillingsCount(data) {
    setLoading835Billing(true);

    setBillingData835([]);

    await dashboardService
      .get835BillingCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clinicResponse = result.resultData;
          let totalCounter = 0.0;
          const newBillingData = [];

          clinicResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region, onlineStaffCount: clinicItem.amt ? clinicItem.amt : 0 }
            newBillingData.push(clinicObj);
            const amtparam = (clinicItem.amt && clinicItem.amt != null) ? clinicItem.amt : 0.0
            totalCounter = totalCounter + amtparam
          })

          setBillingData835(newBillingData);
          setTotal835BillingCount(parseFloat(totalCounter.toFixed(2)))
        }
        setLoading835Billing(false);
      })
      .catch((error) => {
        setLoading835Billing(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  }

  async function get837BillingsCount(data) {
    setLoading837Billing(true);

    setBillingData837([]);

    await dashboardService
      .get837BillingCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clinicResponse = result.resultData;
          let totalCounter = 0.0;
          const newBillingData = [];

          clinicResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region, onlineStaffCount: clinicItem.amt ? clinicItem.amt : 0.0 }
            newBillingData.push(clinicObj);
            const amtparam = (clinicItem.amt && clinicItem.amt != null) ? clinicItem.amt : 0.0
            totalCounter = totalCounter + amtparam
          })

          setBillingData837(newBillingData);
          setTotal837BillingCount(parseFloat(totalCounter.toFixed(2)))
        }
        setLoading837Billing(false);
      })
      .catch((error) => {
        setLoading837Billing(false);
        console.log(error)
        NOTIFICATION_MESSAGE.error(error);
      });
  }

  async function getBillingClaimsCount(data) {
    setLoadingClaimsBilled(true);

    setClaimsBilledData([]);

    await dashboardService
      .getBillingClaimCount(data)
      .then((result) => {
        if (result.resultData.length > 0) {
          const clinicResponse = result.resultData;
          let totalCounter = 0.0;
          const newClaimsData = [];

          clinicResponse.map((clinicItem) => {
            let clinicObj = { region: clinicItem.region, onlineStaffCount: clinicItem.amt ? clinicItem.amt : 0.0 }
            newClaimsData.push(clinicObj);
            const amtparam = (clinicItem.amt && clinicItem.amt != null) ? clinicItem.amt : 0.0
            totalCounter = totalCounter + amtparam
          })

          setClaimsBilledData(newClaimsData);
          setTotalClaimsBilledCount(parseFloat(totalCounter.toFixed(2)))
        }
        setLoadingClaimsBilled(false);
      })
      .catch((error) => {
        setLoadingClaimsBilled(false);
        console.log(error)
        NOTIFICATION_MESSAGE.error(error);
      });
  }
  useEffect(() => {
    getRegion();
  }, []);

  const getRegion = async () => {
    ApiHelper.getRequest(ApiUrls.GET_REGIONS)
      .then((result) => {
        let data = result.resultData;
        dispatch({
          type: GET_REGION,
          payload: data,
        });
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };
  function getAddedAndRemovedSeats(data) {
    return data.reduce(
      (acc, item) => {
        const value = Number(item.totalSeatsChanged) || 0;
        if (value > 0) {
          acc.added += value;
        } else if (value < 0) {
          acc.removed += Math.abs(value);
        }
        return acc;
      },
      { added: 0, removed: 0 }
    );
  }

  const getSeatsHistory = async (data) => {
    setSeatsLoading(true)
    var apiParam = "";
    if (data?.startDate && data?.endDate) {
      const startDate = encodeURIComponent(data.startDate);
      const endDate = encodeURIComponent(data.endDate);
      apiParam = `startDate=${startDate}&endDate=${endDate}`;
    } else {
      const endDate = moment().format('YYYY-MM-DD');
      const startDate = moment().startOf('month').format('YYYY-MM-DD');
      apiParam = `startDate=${startDate}&endDate=${endDate}`;
    }
    ApiHelper.getRequest(`${ApiUrls.GET_USER_SEATS_HISTORY}${apiParam}`)

      .then((result) => {
        let data = result.resultData;

        const grouped = Object.values(
          data.reduce((acc, item) => {
            const clinicId = item.clinicId;
            const change = Number(item.totalSeatsChanged) || 0;

            if (!acc[clinicId]) {
              acc[clinicId] = {
                clinicId,
                clinicName: item.clinicName,
                totalAddition: 0,
                totalRemoval: 0,
                total: 0
              };
            }

            if (change > 0) {
              acc[clinicId].totalAddition += change;
            } else if (change < 0) {
              acc[clinicId].totalRemoval += change;
            }

            return acc;
          }, {})
        );

        grouped.forEach(item => {
          item.total = item.totalAddition - Math.abs(item.totalRemoval);
        });
        setSelectedSeatList(grouped)
        const newData = getAddedAndRemovedSeats(data);
        const totalSeatsChangedSum = data.reduce(
          (sum, item) => sum + (Number(item.totalSeatsChanged) || 0),
          0
        );
        setUserSeatsHistory([{ 'region': 'Total Additions: ', "onlineStaffCount": newData.added, "clicked": 1 }, { 'region': 'Total Removal: ', "onlineStaffCount": newData.removed, clicked: -1 }]);
        setTotalSeatsHistoryCount(totalSeatsChangedSum)
        setSeatsLoading(false)
      })
      .catch((error) => {
        NotificationManager.error(error.message);
        setSeatsLoading(false)
      });
  };

  const getPreviousMonthsSeatsHistory = async () => {
    const startOfPrevMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    const endOfPrevMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    ApiHelper.getRequest(`${ApiUrls.GET_USER_SEATS_HISTORY}startDate=${startOfPrevMonth}&endDate=${endOfPrevMonth}`)
      .then((result) => {
        let data = result.resultData;
        const totalSeatsChangedSum = data.reduce(
          (sum, item) => sum + (Number(item.totalSeatsChanged) || 0),
          0
        );
        setTotalSeatsHistoryCountPrevious(totalSeatsChangedSum)
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const [showDialog, setShowDialog] = useState(false)
  const [operation, setOperation] = useState(0)

  const onClickItem = (clickedVal) => {

    switch (clickedVal) {
      case 1:
        setOperation(1)
        break;

      case -1:
        setOperation(-1)
        break;

      default:
        break;
    }
    setShowDialog(true)
  }

  useEffect(() => {

  }, [day, siteIds]);

  return <>
    <div>
      <div className="row">
        <div className="col-sm-5 col-lg-5 col-md-5">
          <h4 className="f-24 mt-3">Welcome to Dashboard</h4>
        </div>
        <div className="col-sm-7 col-lg-7 col-md-7 d-flex justify-content-end align-items-center">
          {day.value === "custom" && (
            <div className="d-flex mr-2">
              <div className="mr-2 date-field" style={{ marginTop: "10px" }}>
                <DatePickerKendoRct
                  value={customStartDate}
                  onChange={(e) => setCustomStartDate(e.target.value)}
                  placeholder="Start Date"
                />
              </div>
              <div className="date-field" style={{ marginTop: "10px" }}>
                <DatePickerKendoRct
                  value={customEndDate}
                  onChange={(e) => setCustomEndDate(e.target.value)}
                  placeholder="End Date"
                />
              </div>
            </div>
          )}
          <div style={{ minWidth: "200px" }}>
            <DropDownKendoRct
              onChange={handleChange}
              data={Days}
              value={day}
              textField="name"
              dataItemKey="value"
              defaultValue={Days[0]}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <DashboardCard image={clinic_color} heading={"Clinics"} loading={loadingClinicCount} data={allClinicData} total={totalClinicCount} />
        <DashboardCard image={clinic_users} heading={"Staff"} loading={loadingStaffCount} data={allStaffData} total={totalStaffCount} />
        <DashboardCard image={clinic_patients} heading={"Clients"} loading={loadingAllClientCount} data={allClientData} total={totalClientCount} />

        <DashboardCard image={total_billing} heading={"Total Billing 835"} loading={loading835Billing} data={billingData835} total={total835BillingCount} isCurrency={true} />
        <DashboardCard image={total_billing} heading={"Total Billing 837 "} loading={loading837Billing} data={billingData837} total={total837BillingCount} isCurrency={true} />
        <DashboardCard image={claimIcon} heading={"Total Claims Billed"} loading={loadingClaimsBilled} data={claimsBilledData} total={totalClaimsBilledCount} />
        <DashboardCard image={userSeat} heading={"User Seats History"} sub_heading={day.value === 1 ? "Filter: MTD" : ""} loading={seatsLoading} data={userSeatsHistory} total={totalSeatsHistoryCount} canClickValues={true} onClick={onClickItem} additionalTotal={totalSeatsHistoryCountPrevious} additionalTotalTitle={`Total Prev. month UL (${require('moment')().subtract(1, 'month').format('MMMM')})`} />
        <DashboardCard image={online_users} heading={"Current Online Users"} loading={loadingOnlineUsers} data={onlineusersData} total={totalOnlineStaffCount} />

      </div>
      {
        showDialog && <DashBoardCardDetails
          onClose={() => setShowDialog(false)}
          selectedList={seatListToView}
          operation={operation}
        ></DashBoardCardDetails>
      }
    </div>
  </>;
}
export default Dashboard;
